import React from 'react';
import Dialog from '@dashboard/components/Dialog';
import { Form } from '@dashboard/components/Formik';
import { useBlockEmail } from '@dashboard/hooks/useBlockedEmails';

const BlockedCustomerCreateDialog = ({ open, onClose }) => {
  const blockEmail = useBlockEmail({ onSuccess: onClose });

  return (
    <Dialog
      title="Block email"
      cancelButton={null}
      confirmButton={null}
      size="lg"
      open={open}
      onCancel={onClose}
      description="This email will not be able to complete any checkout, event, or form page in your store. Existing subscriptions for this email will continue to renew."
    >
      <Form
        showState={false}
        initialValues={{ email: '', note: '' }}
        onSubmit={async values => {
          try {
            const data = await blockEmail.mutateAsync({
              email: values.email,
              ...(values.note?.trim() && { note: values.note.trim() }),
            });
            return { data };
          } catch (error) {
            return { error };
          }
        }}
        fields={() => [
          {
            name: 'email',
            label: 'Email address',
            type: 'email',
            required: true,
            placeholder: 'customer@example.com',
            helpText: 'We won’t notify the customer that their email has been blocked.',
          },
          {
            name: 'note',
            label: 'Reason (optional)',
            type: 'textarea',
            placeholder: 'Add a reason for blocking this email',
            helpText: 'Only you and your team can see this.',
            rows: 3,
          },
        ]}
        formSubmitAlign="end"
        submitButton={{ label: 'Block email', appearance: 'primary' }}
        cancelButton={{ label: 'Cancel', appearance: 'secondary', onClick: onClose }}
      />
    </Dialog>
  );
};

export default BlockedCustomerCreateDialog;
